import { render, staticRenderFns } from "./ExpenseList.vue?vue&type=template&id=622e455e"
import script from "./ExpenseList.vue?vue&type=script&lang=js"
export * from "./ExpenseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports